/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable new-cap */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { checkAlipayApply, getAlipaySign } from '@/api/apply-product';
import type { AlipayCheckStatus, SignAlipay } from '@/api/apply-product/types';
import NativeApi from '@/api/native';
import { SceneTypeEnum } from '@/enums/scene-type';
import { ALIPAYMINI_COMMODITY, NEW_YINHE_COMMODITY } from '@/shared/commodity';
import platform from '@/shared/utils/platform';
import { Vue, Component } from 'vue-property-decorator';

const businessType = '26';

@Component
export default class AlipayMixins extends Vue {
  // 查询签约
  private checkAlipaySign: AlipayCheckStatus = Object.create(null);

  // 新银河 & 支付宝小银河
  public get getAlipayStatus(): boolean {
    return (
      this.checkAlipaySign
      && ['SUCCEEDED'].indexOf(this.checkAlipaySign.signState) >= 0
    );
  }

  // 新银河-查询签约
  public async checkAlipay(params:{
    scene: SceneTypeEnum,
    creditApplyId?: string, // 授信id 借款场景传入
    loanOrderId?: string, // 订单号 还款场景传入
  }): Promise<void> {
    try {
      const params1 = {
        productId: platform.isAlipayMini ? ALIPAYMINI_COMMODITY : NEW_YINHE_COMMODITY,
        ...params,
      };
      this.checkAlipaySign = await checkAlipayApply(params1);
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async alipaySignParams(
    params:{
      scene: SceneTypeEnum,
      creditApplyId?: string, // 授信id 借款场景传入
      loanOrderId?: string, // 订单号 还款场景传入
    },
  ): Promise<SignAlipay> {
    const params1 = {
      productId: platform.isAlipayMini ? ALIPAYMINI_COMMODITY : NEW_YINHE_COMMODITY,
      ...params,
    };
    const alipaySignApply: SignAlipay = await getAlipaySign(params1);
    return alipaySignApply;
  }

  // 新银河-签约申请
  public async alipaySign(params:{
    scene: SceneTypeEnum,
    creditApplyId?: string, // 授信id 借款场景传入
    loanOrderId?: string, // 订单号 还款场景传入
  }): Promise<void> {
    try {
      const alipaySignApply = await this.alipaySignParams(params);
      if (alipaySignApply && alipaySignApply.params) {
        const alipayParams = {
          preOrderInfo: alipaySignApply.params,
          businessType,
        };
        NativeApi.signWithAliPay(alipayParams).then(async () => {
          await this.checkAlipay(params);
        });
      }
    } catch (e: any) {
      throw new Error(e);
    }
  }
}
